export default __webpack_public_path__ + "static/media/4234.445eeae7.png";